import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const MoneyIdiomsExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Money Idioms and Expressions</h2>
      <p>
        These idiomatic expressions about money, spending, and saving are common in everyday
        conversation. Their meaning cannot be understood from the individual words alone, so learn
        them as whole phrases.
      </p>

      <h3><FaLightbulb /> Common expressions</h3>
      <ul>
        <li><strong>To foot the bill</strong> — to pay for something, especially something expensive.</li>
        <li><strong>To tighten one's belt</strong> — to spend less money than usual.</li>
        <li><strong>To live beyond one's means</strong> — to spend more money than one earns.</li>
        <li><strong>To splash out on</strong> — to spend a lot of money on something enjoyable.</li>
        <li><strong>To squirrel away</strong> — to save money carefully for the future.</li>
        <li><strong>To break the bank</strong> — to cost too much or use up all of one's money.</li>
        <li><strong>A rip-off</strong> — something that is not worth the price paid.</li>
        <li><strong>To make ends meet</strong> — to manage financially with the money one has.</li>
        <li><strong>A nest egg</strong> — savings set aside for the future.</li>
        <li><strong>To go Dutch</strong> — to split the bill equally.</li>
      </ul>

      <h3><FaLightbulb /> In context</h3>
      <div className="grammar-flex-table">
        {[
          ['Expression', 'Meaning', 'Example'],
          ['To foot the bill', 'To pay for something', 'Your phone foots the bill with a single tap.'],
          ["To tighten one's belt", 'To spend less money', 'With rising inflation, many families are tightening their belts.'],
          ['To splash out on', 'To spend freely', 'He splashed out on a new smartphone.'],
          ['To make ends meet', 'To manage financially', 'Low-income workers often struggle to make ends meet.'],
        ].map(([expression, meaning, example], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{expression}</div>
            <div className="grammar-cell">{meaning}</div>
            <div className="grammar-cell">{example}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoneyIdiomsExplanation;
